import { useState } from 'react'
import { motion } from 'framer-motion'
import { HiX, HiCheck } from 'react-icons/hi'

interface ComingSoonModalProps {
  onClose: () => void
}

export function ComingSoonModal({ onClose }: ComingSoonModalProps) {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (email.trim()) {
      // Store email in localStorage for now (would be sent to backend later)
      const emails = JSON.parse(localStorage.getItem('statscout_waitlist') || '[]')
      if (!emails.includes(email)) {
        emails.push(email)
        localStorage.setItem('statscout_waitlist', JSON.stringify(emails))
      }
      setSubmitted(true)
    }
  }

  return (
    <motion.div
      className="coming-soon-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
    >
      <motion.div
        className="coming-soon-modal"
        initial={{ opacity: 0, scale: 0.9, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.9, y: 20 }}
        transition={{ type: 'spring', duration: 0.5 }}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="coming-soon-close" onClick={onClose} aria-label="Close">
          <HiX />
        </button>

        <div className="coming-soon-icon">🚀</div>

        <h2 className="coming-soon-title">Launching Soon</h2>

        <p className="coming-soon-desc">
          We're putting the finishing touches on StatScout.
          Join the waitlist to be notified when we launch and get early access.
        </p>

        {!submitted ? (
          <form className="coming-soon-email-form" onSubmit={handleSubmit}>
            <input
              type="email"
              className="coming-soon-email-input"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" className="cta-button">
              Notify Me
            </button>
          </form>
        ) : (
          <motion.div
            className="coming-soon-success"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <HiCheck style={{ fontSize: '1.5rem' }} />
            <span>You're on the list! We'll be in touch soon.</span>
          </motion.div>
        )}
      </motion.div>
    </motion.div>
  )
}
